import {
  buildCanonicalMarketingPagePath,
  extractPageLocale,
} from "./host-guard";

export const RIVETAI_ANALYTICS_SURFACE = {
  marketingWebsite: "marketing_website",
  productApp: "product_app",
} as const;

export type RivetaiAnalyticsSurface =
  (typeof RIVETAI_ANALYTICS_SURFACE)[keyof typeof RIVETAI_ANALYTICS_SURFACE];

export const POSTHOG_PAGEVIEW_EVENT = "$pageview";

export const buildPosthogPageViewProperties = (
  surface: RivetaiAnalyticsSurface,
  pathname: string,
  search = "",
): Record<string, string> => {
  const normalizedSearch = search.startsWith("?")
    ? search
    : search
      ? `?${search}`
      : "";
  const pathWithSearch = `${pathname}${normalizedSearch}`;
  const canonicalPath = buildCanonicalMarketingPagePath(pathname);
  const pageLocale = extractPageLocale(pathname);

  if (typeof window === "undefined") {
    return {
      rivetai_surface: surface,
      $pathname: canonicalPath,
    };
  }

  return {
    rivetai_surface: surface,
    $current_url: `${window.location.origin}${pathWithSearch}`,
    $pathname: canonicalPath,
    $host: window.location.host,
    ...(normalizedSearch ? { $search: normalizedSearch } : {}),
    ...(pageLocale ? { page_locale: pageLocale } : {}),
  };
};
